/** Popsy Kids product-card upgrade. */
class PopsyCardSizeSelector extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.#onClick);
    this.#syncSelectedVariant();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const option = event.target.closest('.popsy-card-size-selector__option');
    if (!(option instanceof HTMLButtonElement) || option.disabled || option.dataset.available !== 'true') return;

    event.preventDefault();
    event.stopPropagation();
    this.querySelectorAll('.popsy-card-size-selector__option').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === option));
    });
    this.#applyVariant(option);
  };

  #syncSelectedVariant() {
    const selected = this.querySelector('.popsy-card-size-selector__option[aria-pressed="true"]');
    if (selected instanceof HTMLButtonElement) {
      this.#applyVariant(selected, false);
      return;
    }

    // All sizes are sold out: keep every option visible and disable native ATC.
    this.#setAddToCartState(false);
    const card = this.closest('product-card');
    const variantInput = card?.querySelector('.buy-buttons-block product-form-component input[name="id"]');
    if (variantInput instanceof HTMLInputElement) variantInput.value = '';
  }

  #applyVariant(option, updatePrice = true) {
    const card = this.closest('product-card');
    if (!card) return;

    const variantInput = card.querySelector('.buy-buttons-block product-form-component input[name="id"]');
    if (variantInput instanceof HTMLInputElement) variantInput.value = option.dataset.variantId || '';

    this.#setAddToCartState(option.dataset.available === 'true');
    this.#updateProductLinks(card, option.dataset.variantId || '');

    if (updatePrice) {
      const template = option.querySelector('template[data-price-template]');
      const priceContainers = card.querySelectorAll('product-price [ref="priceContainer"]');
      const currentPrice = priceContainers[priceContainers.length - 1];
      const replacement = template?.content.firstElementChild?.cloneNode(true);
      if (currentPrice && replacement) currentPrice.replaceWith(replacement);
    }
  }

  #setAddToCartState(available) {
    const card = this.closest('product-card');
    const container = card?.querySelector('.buy-buttons-block product-form-component add-to-cart-component');
    const button = container?.querySelector('[ref="addToCartButton"]');
    if (!(button instanceof HTMLButtonElement)) return;

    button.disabled = !available;
    const label = button.querySelector('.add-to-cart-text__content');
    if (label) label.textContent = available ? this.dataset.addLabel || 'Add to cart' : this.dataset.soldOutLabel || 'Sold out';
  }

  #updateProductLinks(card, variantId) {
    if (!variantId) return;
    card.querySelectorAll('.product-card__link, [ref="productTitleLink"], [ref="cardGalleryLink"]').forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });
  }
}

if (!customElements.get('popsy-card-size-selector')) {
  customElements.define('popsy-card-size-selector', PopsyCardSizeSelector);
}
